import { Routes, Route } from 'react-router-dom';
import Dashboard from './Pages/Dashboard';
import Login from './Pages/Login';
import Product from './Pages/Product';
import Purchase from './Pages/Purchases';
import Upload from "./Pages/Upload";
import SuppliersData from "./Pages/SuppliersData";
import ViewRecord from "./Pages/ViewRecord";
import ViewRawsRecord from "./Pages/ViewRawsData";
import CompareQuotes from "./Pages/CompareQuotes";
import SupplierContacts from "./Pages/SupplierContacts";
import ForgotPassword from "./Pages/ForgotPassword";
import Raws from './Pages/Raws';
import AddRaws from "./Pages/AddRaws";
import DnReports from "./Pages/DnReports";
import AddSupplier from "./Pages/AddSupplier";
import AddRecord from "./Pages/AddRecord";
import ImportSuppliers from "./Pages/ImportSuppliers";
import UsersPage from './Pages/Admin/UsersPage';
import SuppliersPage from './Pages/Admin/SuppliersPage';
import RolesPage from './Pages/Admin/RolesPage';
import DropdownManager from './Pages/Admin/DropdownManager';
import PurchasingLibrary from './Pages/Library/PurchasingLibrary';
import QuotingHistory from './Pages/Library/QuotingHistory';
import Vendors from './Pages/Library/Vendors';
import Inventory from './Pages/Inventory';
import RequestQuote from './Pages/NutriForm/RequestQuote';
import AddNewRFQ from './Pages/NutriForm/AddNewRFQ';
import FormulaRepository from './Pages/NutriForm/FormulaRepository';
import AddNewFormula from './Pages/NutriForm/AddNewFormula';
import DraftEstimate from './Pages/NutriForm/DraftEstimate';
import AddNewDraftEstimate from './Pages/NutriForm/AddNewDraftEstimate';
import Estimate from './Pages/NutriForm/Estimate';
import Overview from './Pages/NutriForm/Overview';
import MonthlyShippingCost from './Pages/NutriForm/MonthlyShippingCost';
import AllJobs from './Pages/NutriForm/AllJobs';
import NewRecordQueue from './Pages/NutriForm/NewRecordQueue';
import ProtectedRoute from './Pages/Components/ProtectedRoute';

const App = () => {

  return (
      <>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* M6 fix: Protected routes — require authentication */}
          <Route path="/home" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/purchases" element={<ProtectedRoute><Purchase /></ProtectedRoute>} />
          <Route path="/parts" element={<ProtectedRoute><Raws /></ProtectedRoute>} />
          <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
          <Route path="/overview" element={<ProtectedRoute><Overview /></ProtectedRoute>} />
          <Route path="/request-quote" element={<ProtectedRoute><RequestQuote /></ProtectedRoute>} />
          <Route path="/request-quote/new" element={<ProtectedRoute><AddNewRFQ /></ProtectedRoute>} />
          <Route path="/request-quote/edit" element={<ProtectedRoute><AddNewRFQ /></ProtectedRoute>} />
          <Route path="/request-quote/view" element={<ProtectedRoute><AddNewRFQ /></ProtectedRoute>} />
          <Route path="/formula" element={<ProtectedRoute><FormulaRepository /></ProtectedRoute>} />
          <Route path="/formula/new" element={<ProtectedRoute><AddNewFormula /></ProtectedRoute>} />
          <Route path="/formula/edit" element={<ProtectedRoute><AddNewFormula /></ProtectedRoute>} />
          <Route path="/formula/view" element={<ProtectedRoute><AddNewFormula /></ProtectedRoute>} />
          <Route path="/draft-estimate" element={<ProtectedRoute><DraftEstimate /></ProtectedRoute>} />
          <Route path="/draft-estimate/new" element={<ProtectedRoute><AddNewDraftEstimate /></ProtectedRoute>} />
          <Route path="/draft-estimate/edit" element={<ProtectedRoute><AddNewDraftEstimate /></ProtectedRoute>} />
          <Route path="/draft-estimate/view" element={<ProtectedRoute><AddNewDraftEstimate /></ProtectedRoute>} />
          <Route path="/estimate" element={<ProtectedRoute><Estimate /></ProtectedRoute>} />
          <Route path="/estimate/new" element={<ProtectedRoute><AddNewDraftEstimate /></ProtectedRoute>} />
          <Route path="/estimate/edit" element={<ProtectedRoute><AddNewDraftEstimate /></ProtectedRoute>} />
          <Route path="/monthly-shipping-cost" element={<ProtectedRoute><MonthlyShippingCost /></ProtectedRoute>} />
          <Route path="/all-jobs" element={<ProtectedRoute><AllJobs /></ProtectedRoute>} />
          <Route exact path="/product/:productId" element={<ProtectedRoute><Product/></ProtectedRoute>}/>
          <Route path="/suppliers-data" element={<ProtectedRoute><SuppliersData /></ProtectedRoute>} />
          <Route path="/suppliers-data/:supplierId" element={<ProtectedRoute><SuppliersData /></ProtectedRoute>} />
          <Route path="/suppliers-contacts" element={<ProtectedRoute><SupplierContacts /></ProtectedRoute>} />
          <Route exact path="/view/:recordId/:dataId" element={<ProtectedRoute><ViewRecord /></ProtectedRoute>} />
          <Route exact path="/compare-quotes/:keyword" element={<ProtectedRoute><CompareQuotes /></ProtectedRoute>} />
          <Route exact path="/view-raws/:dataId" element={<ProtectedRoute><ViewRawsRecord /></ProtectedRoute>} />
          <Route exact path="/add-raws" element={<ProtectedRoute><AddRaws /></ProtectedRoute>} />
          <Route exact path="/dn-reports" element={<ProtectedRoute><DnReports /></ProtectedRoute>} />
          <Route exact path="/add-supplier" element={<ProtectedRoute><AddSupplier /></ProtectedRoute>} />
          <Route exact path="/add-supplier-record/:recordId" element={<ProtectedRoute><AddRecord /></ProtectedRoute>} />
          <Route exact path="/add-supplier-record/:recordId/:supplierDataId" element={<ProtectedRoute><AddRecord /></ProtectedRoute>} />
          <Route exact path="/add-supplier-record" element={<ProtectedRoute><AddRecord /></ProtectedRoute>} />
          <Route exact path="/import-suppliers" element={<ProtectedRoute><ImportSuppliers /></ProtectedRoute>} />
          <Route exact path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
          <Route exact path="/admin-suppliers" element={<ProtectedRoute><SuppliersPage /></ProtectedRoute>} />
          <Route exact path="/roles" element={<ProtectedRoute><RolesPage /></ProtectedRoute>} />
          <Route exact path="/new-records" element={<ProtectedRoute><NewRecordQueue /></ProtectedRoute>} />
          <Route exact path="/dropdown-manager" element={<ProtectedRoute><DropdownManager /></ProtectedRoute>} />
          <Route exact path="/purchasing-library" element={<ProtectedRoute><PurchasingLibrary /></ProtectedRoute>} />
          <Route exact path="/quoting-history" element={<ProtectedRoute><QuotingHistory /></ProtectedRoute>} />
          <Route exact path="/vendors" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
          <Route exact path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
        </Routes>
      </>
  );
};

export default App;
